import { useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { statusPrestationsValues } from "../../utils/constants";
import dayjs from "../../utils/dayjs";
import { UserContext } from "../context/User.context";

export const usePrestationDisabler = () => {
  const { prestation, loading } = useSelector(state => state.prestation);
  const [disabled, setDisabled] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!prestation || !prestation.status || !prestation.finalStartDate) {
      setDisabled(true);
    }

    const isFinish = [
      statusPrestationsValues.finish,
      statusPrestationsValues.finish_notsigned,
      statusPrestationsValues.finish_permanance,
      statusPrestationsValues.cancel,
    ].includes(prestation.status);

    if (isFinish) {
      const day = dayjs(prestation.finalStartDate);
      const now = dayjs();
      const diffInDays = now.diff(day, "day");
      const cutoffDate = dayjs("2024-06-15");
      // diffInDays >= 7 ||
      // Set disabled to true if more than 7 days have passed or if before the cutoff date
      if (day.isBefore(cutoffDate)) {
        if (user.email === "admin@oseo.ch") {
          // setDisabled(false);
        } else {
          console.log('SHOULD block suite à facturation -> à confirmer')
          // setDisabled(true);
        }
      } else {
        setDisabled(false);
      }
    } else {
      setDisabled(false);
    }
  }, [prestation]);

  return [disabled];
};
